// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Router from 'vue-router'
import "babel-polyfill"
import moment from 'moment'
import QS from 'qs'
import {http} from './api/http.js'
import {registerTrackDirective} from './utils/track/directive.js'
import {installRouterHook} from './utils/track/routerHook.js'
import VueCodeMirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import * as echarts from 'echarts'
import { AutoComplete } from 'ant-design-vue';
import {
  Button, Layout, Row, Col, Menu, Icon, Card, Tabs,
  Table, Form, Tree, Popover, Divider, Input, Select, Radio,
  message, Popconfirm, Spin, Switch, Pagination, ConfigProvider,
  Dropdown, Modal, Upload, Drawer, DatePicker, InputNumber, Tag,
  Alert, Empty, Tooltip, Steps, Breadcrumb, Avatar, List, TreeSelect,
  Checkbox, Anchor, Badge, Affix, Timeline, Rate, Carousel, Statistic, Cascader
} from 'ant-design-vue'
import store from './store/index.js'
import '../static/css/common.css'
import './views/planFlow/styles/listTable.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueBus from 'vue-bus'
import $ from 'jquery';

// wujie 微前端
import WujieVue from 'wujie-vue2'
Vue.use(WujieVue)

window.jQuery = $;
window.$ = $;
import draggable from 'vuedraggable';

Vue.component('draggable', draggable);

import * as vClickOutside from 'v-click-outside-x';

Vue.use(vClickOutside);
Vue.use(VueBus)
Vue.use(VueQuillEditor)
Vue.use(VueCodeMirror)

//处理控制台报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.config.productionTip = false
Vue.prototype.QS = QS
//全局引用
Vue.prototype.http = http
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$moment = moment;
Vue.prototype.$echarts = echarts;
Vue.use(moment);
//引入antd样式
Vue.use(Button);
Vue.use(Layout);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Card);
Vue.use(Tabs);
Vue.use(Table);
Vue.use(Form);
Vue.use(Tree);
Vue.use(Popover);
Vue.use(Divider);
Vue.use(Input);
Vue.use(Select);
Vue.use(Radio);
Vue.use(Popconfirm);
Vue.use(Spin);
Vue.use(Switch);
Vue.use(Pagination);
Vue.use(ConfigProvider);
Vue.use(Dropdown);
Vue.use(Modal);
Vue.use(Upload);
Vue.use(Drawer);
Vue.use(DatePicker);
Vue.use(InputNumber);
Vue.use(Tag);
Vue.use(Alert);
Vue.use(Empty);
Vue.use(Tooltip);
Vue.use(Steps);
Vue.use(Breadcrumb);
Vue.use(Avatar);
Vue.use(List);
Vue.use(TreeSelect);
Vue.use(Checkbox);
Vue.use(Anchor);
Vue.use(Badge);
Vue.use(Affix);
Vue.use(Timeline);
Vue.use(Rate);
Vue.use(Carousel);
Vue.use(Cascader);
Vue.component('a-statistic', Statistic);
Vue.component('a-auto-complete', AutoComplete);
import { FormModel } from 'ant-design-vue';
Vue.use(FormModel);
// 注册一个全局指令图片加载
Vue.component('lazy-image', {
  props: ['src', 'imgStyle', 'alt'],
  data() {
    return {
      loaded: false
    }
  },
  methods: {
    loadImage() {
      const image = new Image()
      image.src = this.src
      image.onload = () => {
        this.loaded = true
      }
    },
    onImageLoad() {
      this.loaded = true
    }
  },
  mounted() {
    this.loadImage()
  },
  computed: {
    fadeClasses() {
      return {
        'fade-in': true,
        'loaded': this.loaded
      }
    }
  },
  template: `
    <div>
      <div v-if="!loaded" :style="imgStyle" style="padding-left: 3px;">Image loading...</div>
      <div :class="fadeClasses">
        <img v-if="loaded" :src="src" :alt="alt" :style="imgStyle" @load="onImageLoad">
      </div>
    </div>
  `
})
/**权限指令**/
const hasDirectiveEls = new Set();
let hasDirectiveStoreUnsubscribe = null;

function applyHasPermission(el) {
  const perm = el.dataset.value;
  if (!perm) return;
  if (Vue.prototype.$_has(perm)) {
    el.style.removeProperty('display');
  } else {
    el.style.display = 'none';
  }
}

function refreshAllHasDirectiveEls() {
  hasDirectiveEls.forEach(applyHasPermission);
}

Vue.directive('has', {
  inserted(el) {
    hasDirectiveEls.add(el);
    applyHasPermission(el);
    if (!hasDirectiveStoreUnsubscribe) {
      hasDirectiveStoreUnsubscribe = store.subscribe((mutation) => {
        if (mutation.type === 'setButtons') {
          refreshAllHasDirectiveEls();
        }
      });
    }
  },
  unbind(el) {
    hasDirectiveEls.delete(el);
  }
});
//权限检查方法
Vue.prototype.$_has = function (value) {
  let isExist = false;
  //  获取拥有的权限
  let arr = store.state.publics.buttons;
  if (arr.indexOf(value) != -1) {
    isExist = true;
  }
  return isExist;
};

// 埋点：v-track + 路由守卫
registerTrackDirective(Vue);
installRouterHook(router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js